import script from "./InstructionPerfectumPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionPerfectumPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionPerfectumPage.vue?vue&type=style&index=0&id=5ed6143e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed6143e"]])

export default __exports__